import {CLStore} from 'common/src/redux/store';
import initializeCreativesAgents from './initializeCreativesAgents';

function initializeCreatives(store: CLStore) {
  initializeCreativesAgents(store);
}

export default initializeCreatives;
